import store from '../../../store';
export default function checkIfCanSeeSuggestion() {
  let exists = false;
  let scopes = store.getters.userScopes;
  if (scopes.includes('suggestions_list_all') || scopes.includes('suggestions_list_company')) {
    exists = true;
  }
  return exists;
}
